const getSourceImage = (sourceName: string): string =>
  `/widget-app/images/${sourceName.replace(/.com|.org/gi, '')}.png`;

export { getSourceImage };
